"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueContainsEventType = exports.queueEventNameCount = exports.debugEventQueue = exports.resetEventQueue = void 0;
var state_1 = require("./state");
var resetEventQueue = function () {
    var state = (0, state_1.getState)();
    state.eventQueue = [];
};
exports.resetEventQueue = resetEventQueue;
var debugEventQueue = function () {
    console.log('debugEventQueue getState().eventQueue', (0, state_1.getState)().eventQueue);
};
exports.debugEventQueue = debugEventQueue;
var queueEventNameCount = function (eventName) {
    var eventQueue = (0, state_1.getState)().eventQueue;
    return Array.isArray(eventQueue) ? eventQueue.filter(function (e) { return e.eventName === eventName; }).length : 0;
};
exports.queueEventNameCount = queueEventNameCount;
var queueContainsEventType = function (eventType) {
    var eventQueue = (0, state_1.getState)().eventQueue;
    return eventQueue.some(function (e) { return e.eventType === eventType; });
};
exports.queueContainsEventType = queueContainsEventType;
